const UserInActiveIcon = () => {
  return (
    <svg width='25' height='24' viewBox='0 0 25 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        opacity='0.4'
        d='M9.5 2C6.88 2 4.75 4.13 4.75 6.75C4.75 9.32 6.76 11.4 9.38 11.49C9.46 11.48 9.54 11.48 9.6 11.49C9.62 11.49 9.63 11.49 9.65 11.49C9.66 11.49 9.66 11.49 9.67 11.49C12.23 11.4 14.24 9.32 14.25 6.75C14.25 4.13 12.12 2 9.5 2Z'
        fill='#292D32'
        fillOpacity='0.5'
      />
      <path
        d='M14.58 14.1499C11.79 12.2899 7.23996 12.2899 4.42996 14.1499C3.15996 14.9999 2.45996 16.1499 2.45996 17.3799C2.45996 18.6099 3.15996 19.7499 4.41996 20.5899C5.81996 21.5299 7.65996 21.9999 9.49996 21.9999C11.34 21.9999 13.18 21.5299 14.58 20.5899C15.84 19.7399 16.54 18.5999 16.54 17.3599C16.53 16.1299 15.84 14.9899 14.58 14.1499Z'
        fill='#292D32'
        fillOpacity='0.5'
      />
      <path
        opacity='0.4'
        d='M20.4901 7.3401C20.6501 9.2801 19.2701 10.9801 17.3601 11.2101C17.3501 11.2101 17.3501 11.2101 17.3401 11.2101H17.3101C17.2501 11.2101 17.1901 11.2101 17.1401 11.2301C16.1701 11.2801 15.2801 10.9701 14.6101 10.4001C15.6401 9.4801 16.2301 8.1001 16.1101 6.6001C16.0401 5.7901 15.7601 5.0501 15.3401 4.4201C15.7201 4.2301 16.1601 4.1101 16.6101 4.0701C18.5701 3.9001 20.3201 5.3601 20.4901 7.3401Z'
        fill='#292D32'
        fillOpacity='0.5'
      />
      <path
        d='M22.49 16.5899C22.41 17.5599 21.79 18.3999 20.75 18.9699C19.75 19.5199 18.49 19.7799 17.24 19.7499C17.96 19.0999 18.38 18.2899 18.46 17.4299C18.56 16.1899 17.97 14.9999 16.79 14.0499C16.12 13.5199 15.34 13.0999 14.49 12.7899C16.7 12.1499 19.48 12.5799 21.19 13.9599C22.11 14.6999 22.58 15.6299 22.49 16.5899Z'
        fill='#292D32'
        fillOpacity='0.5'
      />
    </svg>
  );
};

export { UserInActiveIcon };
